export function isExternalUrl(url) {
    if (!url)
        return false;
    const trimmed = url.trim();
    if (!trimmed.startsWith("http://") && !trimmed.startsWith("https://"))
        return false;
    try {
        return new URL(trimmed).origin !== window.location.origin;
    }
    catch {
        return false;
    }
}
export function toInternalPath(url) {
    const parsed = new URL(url, window.location.origin);
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
